import React, {useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker, removeIgnoreItems } from '../../utils';
import moment from 'moment';
import 'moment-timezone';
import SchedulePageHolder from './SchedulePageStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { getLabel } from '../../utils';
import 'moment/locale/fr';
import SEO from '../../components/SEO/SEO';

const TimezonePicker = (props) => {
	return(
		props.timezones.map((timezoneObject,i) => {
			let timezoneObjectZoneAbbr = moment().tz(timezoneObject.timezone).format('Z');
			let selectedTimezoneAbbr = moment().tz(props.selectedTimezone).format('Z');
			return <li key={`tz-${i}`} itemScope itemType='https://schema.org/scheduleTimezone'><button tabIndex="0" className={`${timezoneObjectZoneAbbr === selectedTimezoneAbbr ? 'selected' : ''}`}
							   onClick={(e) => {
								   e.preventDefault();
								   props.onChange(timezoneObject.timezone);
							   }}>{timezoneObject.label}</button></li>
		})
	)
}
const AccordionItem = (props) => {
	const [opened, setOpened] = useState(false);
	return(
		<div className="schedule-list-wrapper" key={props.number}>
			{
				props.showDate && 
				<div className={'date-label--mobile'} itemProp='startDate'>
					{
						props.showDate
					}
				</div>
			}
			<div className={`accordion ${opened ? 'accordion--showContent' : 'accordion--hideContent'}`} onClick={(e) => {
				setOpened(!opened); 
			}} onKeyDown={() => setOpened(!opened)}>

				<div className="schedule-show-time">
					{props.showDate && <span className="schedule-date" tabIndex="0" itemProp='startDate'>
						{props.showDate}
					</span>}
					<span className="schedule-time" tabIndex="0" itemProp='startTime'>
						{props.timestamp}
					</span>
				</div>
				<div className="schedule-show-details">
					<span className="schedule-title" tabIndex="0" role="button" itemProp='category'>
						{props.title}
					</span>
					<div className={'accordion-content-description'} tabIndex="0">
						{
							props.children
						}
					</div>
				</div>
				<div className="cpac-icon-chevron">
					<FontAwesomeIcon icon = {faChevronDown} />
				</div>
			</div>
		</div>
	)
}
const SchedulePage = (props) => {
	const [content, setContent] = useState([]);
	const [scheduleList, setScheduleList] = useState([]);
	const [selectedTimezone, setSelectedTimezone] = useState(moment.tz.guess());
	const [timezoneObject, setTimezoneObject] = useState([{label:getLabel("PT"),timezone:"America/Los_Angeles"},{label:getLabel("MT"),timezone:"America/Edmonton"},{label:getLabel("CT"),timezone:"America/Winnipeg"},{label:getLabel("ET"),timezone:"America/Toronto"}, {label:getLabel("AT"),timezone:"America/Halifax"}, {label:getLabel("NT"),timezone:"America/St_Johns"}]);
	const [pageDesc, setPageDesc] = useState();
	const [pageThumb, setPageThumb] = useState([]);
	const siteURL = window.location.origin;
	const pageURL = window.location.origin + window.location.pathname;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageTitle = content.title ? content.title + " | CPAC.ca" : "CPAC.ca";

	useEffect(() => {
		setTimezoneObject([{label:getLabel("PT"),timezone:"America/Los_Angeles"},{label:getLabel("MT"),timezone:"America/Edmonton"},{label:getLabel("CT"),timezone:"America/Winnipeg"},{label:getLabel("ET"),timezone:"America/Toronto"}, {label:getLabel("AT"),timezone:"America/Halifax"}, {label:getLabel("NT"),timezone:"America/St_Johns"}])
	}, [props.current_lang]);

	useEffect(() => {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);
		httpGet(serviceUrl, {url: props.url, crafterSite: craftConf.site}).subscribe((data) => {
			if(data.page.scheduleList && data.page.scheduleList.item && data.page.scheduleList.item.length > 0) {
				data.page.scheduleList.item = removeIgnoreItems(data.page.scheduleList);
			}
			let fieldNames = ["title_t", "scheduleList.program_title_t", "scheduleList.title_t", "scheduleList.description_t", "scheduleList.image_s", "thumbnailResult.image_s", "thumbnailResult.altImageTxt_s"]
			languagePicker(data, fieldNames);
			setContent(data.page);
			if(data.page.scheduleList && data.page.scheduleList.item){
				setScheduleList(data.page.scheduleList.item);
			}
			setPageThumb(data.page.thumbnailResult.item[0].image);
		});
		if(props.current_lang === "en"){
			setPageDesc("Full Schedule");
		} else {
			setPageDesc("Horaire");
		}
	},[props.url, props.current_lang]);

	useEffect(()=> {
		props.setCurrentLanguage(props.lan);
	},[props.lan]);

	return(
		<>
		<SEO pageDesc={pageDesc} pageURL={pageURL} title={content.title} pageTitle={pageTitle} image={siteURL + pageThumb} robots="false" pageLocale={pageLocale} />
		<SchedulePageHolder>
			<div className="row">
                <h1 className="page-title" tabIndex="0" itemProp='headline'>{content.title}</h1>
            </div>
			<div className="schedule-timezone-filter" tabIndex="0"><p tabIndex="0">{getLabel("SELECT_YOUR_TIMEZONE")}</p>
				<ul id="js-timezone-picker">
					{
						// Timezone picker
						<TimezonePicker timezones = {timezoneObject}
										selectedTimezone={selectedTimezone}
										onChange={(timezone) => {
											setSelectedTimezone(timezone);
										}}
						/>
					}
				</ul>
			</div>
			<div itemScope itemType='https://schema.org/Schedule'>
			{
				scheduleList.map((element,i)=>{
					let isFirst = i=== 0;
					let isDifferentDate = scheduleList[i-1]!==undefined && moment(element.air_date_dt).tz(selectedTimezone).format('D') !== moment(scheduleList[i-1].air_date_dt).tz(selectedTimezone).format('D');
					let showDates= isFirst || isDifferentDate;
					let formattedDate = showDates ?
						moment(element.air_date_dt).tz(selectedTimezone).locale(props.current_lang).format(props.current_lang==='fr'?'DD MMMM' : 'MMMM DD')
						:false
					return(
						<>
							<AccordionItem number={i} title={element.program_title} timestamp={moment(element.air_date_dt).tz(selectedTimezone).format('HH:mm')} showDate={formattedDate}>
								<p tabIndex="0" itemProp='name'><strong>{element.title}</strong></p>
								<span className='sched-details' tabIndex="0" itemProp='description'>
									<div dangerouslySetInnerHTML={{ __html: element.description.replace(/\n+/g,"<br>") }}></div>
									{element.image && <img src={element.image} tabIndex="0" itemProp='image'/>}
								</span>
							</AccordionItem>
						</>
					)
				})
			}
			</div>
		</SchedulePageHolder>
		</>
	)
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps,mapDispatchToProps)(SchedulePage);